import React from 'react'
import ReactDOM from 'react-dom'
import './Common/styles/index.less'
import App from './Container/App'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')
import * as serviceWorker from './serviceWorker'

React.Component.prototype.$moment = moment
ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
